/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';
import { BagIcon } from '@/components/icons';

export default function CartBadgeIcon({ numberOfItems }: { numberOfItems: number }): ReactElement {
    return (
        <>
            <BagIcon className="size-5 text-header-foreground" data-testid="shopping-cart-icon" />
            {numberOfItems > 0 && (
                <Badge
                    variant="default"
                    className="absolute top-0 right-0 min-w-[13px] h-[13px] rounded-full px-[3px] text-[8px] leading-none font-medium flex items-center justify-center bg-header-cart-badge text-header-cart-badge-foreground lg:-top-1 lg:-right-1 lg:min-w-[18px] lg:h-[18px] lg:px-1 lg:text-xs lg:ps-accent lg:text-primary-foreground"
                    data-testid="shopping-cart-badge">
                    {numberOfItems}
                </Badge>
            )}
        </>
    );
}
